import React from 'react';
import styles from './barcode.module.css'
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PrintRoundedIcon from '@material-ui/icons/PrintRounded';
import Barcode  from 'react-barcode';
import List from '@material-ui/core/List'
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Tooltip from '@material-ui/core/Tooltip';
import DialogTitle from '@material-ui/core/DialogTitle';
import axios from 'axios'
import {getParts} from '../../../containers/app/actions'
import {connect} from 'react-redux';
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import CircularProgress from '@material-ui/core/CircularProgress'

import NewWindow from 'react-new-window'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BarCodeComp = (props) => {
    const [fullScreen,setFullScreen] = React.useState(false)
    const [modal,setModal] = React.useState(false);
    const [loading,setLoading] = React.useState(true);
    const [number,setNumber] = React.useState(1);
    const [productList,setProductList] = React.useState([]);
    const [activeProduct,setActiveProduct] = React.useState("")
    //const [size,setSize] = React.useState(props.part.stickerSize)

    React.useEffect(() => {
        axios({
            method: "post",
            url: "/getPartIncludedProductList",
            data: {
                partId: props.part._id
            }
        }).then(res => {
            if(res.data.success) {
                setProductList(res.data.product)
            } else {
                setProductList([]);
            }
            setLoading(false);
        }).catch(err => {
            setProductList([]);
            setLoading(false);
        })
    },[]);

    const onLoad = () => {
        if(number > 200 ) {
            props.setAlert("Upto 200 maximum Barcode can be printed at once");
            return false; 
        } 
        setLoading(true);
        // console.log('partId:'+props.part._id);
        // console.log('props:');
        // console.log(props);
        // console.log('barcodeNumber:'+props.part.barcodeNumber);
        // console.log('input number:'+number);
        // return false;
        axios({
            method: "post",
            url: "/increaseBarcodeNumber",
            data: {
                partId: props.part._id,
                barcodeNumber: parseInt(number) + parseInt(props.part.barcodeNumber)
            }
        }).then(res => {
            setLoading(false)
            if(res.data.success) {
                setFullScreen(true);
                setModal(false);
                // props.getParts(props.user._id)
            } else if(res.data.success == false){
                props.setAlert(res.data.msg);
                setTimeout(()=>{window.location.reload()},2000);
            } else {
                props.setAlert("Something went wrong Try Again")
            }
        }).catch(err => {
            props.setAlert("Something went wrong Try Again")
        })
    }

    const handleClose = () => {
        props.getParts(props.user._id)
        setFullScreen(false)
    }

    let i = props.part.barcodeNumber; 
    // EXTRA @ICH HEIGHT HAS BEEN GIVEN FOR PRINER SETTINGS
    const sizes = {
        'Small': {
            width: '4in',
			height: '2in',
            padding: '.125in .3in 0',
			float: 'left',
			textAlign: 'center',
			overflow: 'hidden',
        },
        'Medium': { 
            width: '4in',
			height: '3in',
			padding: '.125in .3in 0',
			float: 'left',
			textAlign: 'center',
			overflow: 'hidden',
            fontSize: '12px'
        },
        'Large': {
            width: '4in',
			height: '5in', 
			float: 'left',
			textAlign: 'center',
			overflow: 'hidden',
        }
        
    }
    return ( 
        <React.Fragment>
            <Tooltip title="Print Barcode">
                <IconButton onClick={() => setModal(true)}>
                    <PrintRoundedIcon />
                </IconButton>   
            </Tooltip>

            <Dialog open={modal} onClose={() => setModal(false)} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Print Part Barcode</DialogTitle>

                <DialogContent> 
                    {loading
                        ?
                    <div className={styles.loader}>
                        <CircularProgress />
                    </div>
                        :
                    <React.Fragment>
                        <TextField
                            autoFocus
                            variant="outlined" 
                            id="name"
                            label="Number Of Parts"
                            type="number"
                            fullWidth
                            value={number}
                            onChange={(e) => setNumber(e.target.value)}
                            min={1}
                            max={200}
                        />
                        
                    </React.Fragment>
                    }
                </DialogContent>
                
                <DialogActions>
                    <Button onClick={() => setModal(false)} color="primary" variant="contained">
                        Cancel
                    </Button> 
                    <Button onClick={onLoad} color="primary" variant="contained">
                        Print
                    </Button>
                </DialogActions>
            </Dialog> 
                {fullScreen && 
                <NewWindow>
                    {Array(parseInt(number == "" ? 0 : number)).fill("val").map((val,index) => {
                        i++; 
                        let barcodeVal = props.part.parts_barcode;

                        return (
                            <React.Fragment>
                                <div className={styles.barcode} style={{...sizes[props.part.stickerSize]}}>
                                    {props.part.stickerSize != "Small" && 
                                        <React.Fragment><br /><br /><br /><br /><br /></React.Fragment>}

                                    {props.part.stickerSize == "Large" && 
                                        <React.Fragment><br /><br /><br /><br /><br /></React.Fragment>}

                                    <Barcode value={`${barcodeVal}${('000000' + (i - 1)).slice(-6)}`} />

                                    <h4>{props.part.partName}</h4>

                                    {activeProduct &&
                                        <h5>Product - {activeProduct.productName}</h5>
                                    }
                                </div> 
                                <div className={styles.pageBreak}></div>
                            </React.Fragment>
                        )
                    })}
                </NewWindow>} 
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps,{getParts})(BarCodeComp);